import { Divider, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import registry from "./registry";

function StepModal({ isOpen, onClose, stepIndex, data }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "issbPlan.planDetails.modals"
  });

  const renderModalBody = () => {
    if (stepIndex && !isNaN(stepIndex)) {
      const ModalBodyComponent = registry.resolve(stepIndex);
      return <ModalBodyComponent data={data} />;
    }
    return null;
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          {`${t("step")} ${stepIndex}`}
          <Divider marginTop={3} width="350px" />
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {renderModalBody()}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default StepModal;